import axios from "axios";
import { getAccessTokenCookie } from "./authToken";

const getAuthToken = () => {
  const fromCookie = getAccessTokenCookie();
  if (fromCookie) return fromCookie;

  try {
    const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
    if (!clientId) return null;
    const lastUserKey = Object.keys(localStorage).find(
      (k) => k.startsWith(`CognitoIdentityServiceProvider.${clientId}`) && k.endsWith(".LastAuthUser")
    );
    if (!lastUserKey) return null;
    const username = localStorage.getItem(lastUserKey);
    return localStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.${username}.accessToken`);
  } catch {
    return null;
  }
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ASSISTANT_URL,
  responseType: "json",
});

const unwrapResponse = (response) => response?.data?.data ?? response?.data;
const ensureConfigured = () => {
  if (!process.env.REACT_APP_API_ASSISTANT_URL) {
    throw new Error("REACT_APP_API_ASSISTANT_URL is not configured");
  }
};

const AssistantAPI = {
  async createQuestionAudioUploadUrl(payload, authToken) {
    ensureConfigured();
    const token = authToken || getAuthToken();
    const response = await api.post("/question-audio-upload-url", payload, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return unwrapResponse(response);
  },

  async processExperienceQuestionAudio(payload, authToken) {
    ensureConfigured();
    const token = authToken || getAuthToken();
    const response = await api.post("/process-experience-question-audio", payload, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return unwrapResponse(response);
  },
};

export default AssistantAPI;
